"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlicesProvider = exports.useSlicesContext = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@slicesjs/core");
var react_1 = tslib_1.__importStar(require("react"));
var ReactiveMapProvider_1 = require("./ReactiveMapProvider");
var SlicesContext = (0, react_1.createContext)(undefined);
var useSlicesContext = function () {
    var context = (0, react_1.useContext)(SlicesContext);
    if (!context) {
        throw new Error("It couldn't find a Slices Context. You are probably missing a Provider");
    }
    return context;
};
exports.useSlicesContext = useSlicesContext;
function SlicesProvider(_a) {
    var children = _a.children, originProp = _a.origin, errorComponent = _a.errorComponent, loadingComponent = _a.loadingComponent, reactiveMap = _a.reactiveMap;
    var origin = process.env.NODE_ENV !== 'production' && !originProp
        ? "http://localhost:".concat(core_1.defaultDevServerPort)
        : originProp;
    return (react_1.default.createElement(ReactiveMapProvider_1.ReactiveMapProvider, { reactiveMap: reactiveMap },
        react_1.default.createElement(SlicesContext.Provider, { value: {
                origin: origin,
                errorComponent: errorComponent,
                loadingComponent: loadingComponent,
            } }, children)));
}
exports.SlicesProvider = SlicesProvider;
//# sourceMappingURL=SlicesProvider.js.map